import CollectTabs from './CollectTabs';

export default CollectTabs;
